/* eslint-disable linebreak-style */
/* eslint-disable no-unused-vars */

import React, { useEffect, Suspense, useState } from "react";
import { BrowserRouter, Routes, Route, Router } from "react-router-dom";
import ErrorBoundary from "./errorBoundary/ErrorBoundary";
import { configureAmplify } from "../src/views/Auth/auth";
import MainLayout from "./views/MainLayout";
import { routeList } from "../src/config/routes";
import { commonRoutes } from "../src/config/commonRoutes";
import { globalPath } from "./config/globalPaths";
const PageNotFound = React.lazy(() => import("./views/404"));
import "antd/dist/antd.css";
import "./App.scss";
import CpOnbordingTabs from "./views/Master/CpOnbordingTabs";

const App = () => {
  // const [roles, setRoles] = useState();
  // const [userInfo, setUserInfo] = useState(
  //   localStorage.getItem("loggedOutTime")
  // );

  // useEffect(() => {
  //   configureAmplify(true);
  // }, []);

  // useEffect(() => {
  //   let userInfo = localStorage.getItem("loggedOutTime");
  //   setUserInfo(JSON.parse(userInfo));
  //   setRoles(JSON.parse(localStorage.getItem("userinfo")));
  // }, []);

  // useEffect(() => {
  //   if (!globalPath.includes(window.location.pathname)) {
  //     sessionOut();
  //   }
  // }, []);

  // useEffect(() => {
  //   let loc = window.location.pathname;
  //   let check = loc?.includes("view-client");
  //   if (check) {
  //     localStorage.setItem("viewClient", loc);
  //   }
  // }, []);

  // const sessionOut = () => {
  //   setInterval(() => {
  //     const date = new Date();
  //     if (date.getTime() >= userInfo) {
  //       window.location.assign("/");
  //       let url = localStorage.setItem("viewClient");
  //       localStorage.clear();
  //       localStorage.setItem("viewClient", url);
  //       document.cookie = "userToken=";
  //     }
  //   }, 1000);
  // };

  // const dynamicRoutes = () => {
  //   let temp = [];
  //   routeList.map((item, index) => {
  //     console.log(item);
  //     item.role.some((rt) => {
  //       if (roles && roles.roles.includes(rt)) {
  //         temp.push(
  //           <Route
  //             exact
  //             key={`route_${index}`}
  //             path={item.route}
  //             element={<item.component />}
  //           />
  //         );
  //       }
  //     });
  //   });

  //   return temp;
  // };

  const globalRoutes = () => {
    let temp = [];
    commonRoutes.map((item, index) => {
      temp.push(
        <Route
          exact
          key={`route_${index}`}
          path={item.route}
          element={<item.component />}
        />
      );
    });

    return temp;
  };

  return (
    <BrowserRouter basename="/">
      {/* <MainLayout
        component={
        
        }
      /> */}
      <Suspense fallback={null}>
        <ErrorBoundary>
          <Routes>
            <>
              {globalRoutes()}
              <Route path="*" element={<PageNotFound />} />
              <Route path="/cp-onbording" element={<CpOnbordingTabs />} />
            </>
          </Routes>
        </ErrorBoundary>
      </Suspense>
    </BrowserRouter>
  );
};

export default App;
